/*
  Sykler i butikk på produktsiden, bygget etter Elkjøps "Finn butikk": lagerlinjen
  ("På lager") åpner et panel med kart og butikkliste. På PC står kartet til venstre
  og listen til høyre. På mobil vises listen først, med "Se kartoversikt" nederst.

  Velger kunden en butikk, zoomer kartet dit og kortet åpner seg med kjøpsknapp,
  åpningstid og Butikkinformasjon. Postnummer gir avstand og sorterer listen.

  De fleste kundene er på mobil. Der lukker tilbake-knappen panelet i stedet for å gå
  ut av sykkelsiden, tastaturet kommer ikke av seg selv, "Bruk min posisjon" står i
  listen, og alt som kan trykkes på er minst 44 piksler høyt.

  På mobil er panelet et ark: dra det ned, så lukkes det og sykkelsiden er der igjen.
  Linjen nederst dras opp for kart og ned igjen for butikkene. Alt virker også med
  trykk, for ikke alle vet at det går an å dra.

  Kunden ser aldri hvor mange. Hvert kort gir ett klart svar, for kundene ringer hvis
  noe er uklart: "Utstilt i butikk", eller "Ikke utstilt her nå" sammen med hva vi kan
  gjøre ("Vi kan få den hit på 1-3 dager"). Levering loves bare når sykkelen ligger på
  hovedlageret, ellers stemmer ikke løftet.

  Kortet viser også alt av sykkelen som står i butikken (størrelse, farge), slik XXL
  gjør. Hjul og tilbehør deler ofte strekkode, så de vises bare når de betyr noe.

  Henting velges i kassen ("Hente i vår butikk i Oslo"). Det er fraktvalg, ikke
  Shopifys egen henting, så kjøpsknappen her legger bare sykkelen i handlevognen.

  Lagerboksen bygges av updateStockDisplay i theme.js. Denne filen legger seg rundt
  den, så det følger med når kunden bytter størrelse.

  Data: custom.butikklager, skrevet ut av snippets/butikklager.liquid som ja/nei per
  butikk. Bare sykler.

  ÅPNINGSTIDER STÅR HER I SHOPS OG OPPDATERES IKKE AV SEG SELV. De er kopiert fra
  HERO (store_settings) 04.11.2026. Endres tidene i HERO, må de endres her også.
  Unntak: Trondheim er fra butikksiden. HERO sier stengt lørdag, men kassen viser salg
  de fleste lørdager 10-14 og mandager bare til 17. Skien står som stengt lørdag, som i
  HERO: butikksiden sier 10-15, men kassen viser nesten ikke salg på lørdager.

  Kart: Leaflet og OpenStreetMap. Gratis, ingen nøkkel og ingen informasjonskapsler,
  men kreditten må stå synlig og tjenesten har ingen garanti. Bytt TILES for å bytte
  leverandør. Postnummer slås opp hos Kartverket. Alt lastes først når panelet åpnes,
  så produktsiden blir ikke tyngre. Feiler kartet, vises listen alene.

  Lagerstatus (properties[Lagerstatus]) får butikkene med, så ordren viser hva
  kunden så. Kjøp fra et butikkort legger til "Valgt butikk: Oslo", som også vises i
  handlevognen. HERO leser bare starten av feltet, så dette må stå bakerst.

  Fjern: se toppen av snippets/butikklager.liquid.
*/
(function () {
  if (window.butikklagerLoaded || !window.HTMLDialogElement || !window.theme || !theme.Product || !theme.Product.prototype.updateStockDisplay) { return; }
  window.butikklagerLoaded = true;

  // Hours from Sunday to Saturday, as [opens, closes], or null when closed.
  function week(monToThu, fri, sat) {
    return [null, monToThu, monToThu, monToThu, monToThu, fri, sat];
  }

  var SHOPS = [
    { key: 'oslo', city: 'Oslo', name: 'Unaas Cycling Oslo', address: 'Ensjøveien 17, 0655 Oslo', lat: 59.9147424, lng: 10.7863774, url: '/pages/oslo',
      hours: week(['10:00', '18:00'], ['10:00', '18:00'], ['10:00', '15:00']) },
    { key: 'bergen', city: 'Bergen', name: 'Unaas Cycling Bergen', address: 'Kanalveien 66, 5068 Bergen', lat: 60.3621412, lng: 5.3470525, url: '/pages/bergen',
      hours: week(['10:00', '17:00'], ['10:00', '17:00'], ['10:00', '15:00']) },
    { key: 'trondheim', city: 'Trondheim', name: 'Unaas Cycling Trondheim', address: 'Falkenborgvegen 36, 7044 Trondheim', lat: 63.4351653, lng: 10.4627211, url: '/pages/trondheim',
      hours: [null, ['10:00', '17:00'], ['10:00', '18:00'], ['10:00', '18:00'], ['10:00', '18:00'], ['10:00', '18:00'], ['10:00', '14:00']] },
    { key: 'kristiansand', city: 'Kristiansand', name: 'Unaas Cycling Kristiansand', address: 'Barstølveien 36, 4636 Kristiansand', lat: 58.1713945, lng: 8.1271649, url: '/pages/kristiansand',
      hours: week(['11:00', '18:00'], ['11:00', '17:00'], null) },
    { key: 'skien', city: 'Skien', name: 'Unaas Cycling Skien', address: 'Vestre Buktenveg 21, 3736 Skien', lat: 59.1614308, lng: 9.6342313, url: '/pages/skien',
      hours: week(['10:00', '17:00'], ['10:00', '16:00'], null) }
  ];

  var DAYS = ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'];
  var LEAFLET_JS = 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.js';
  var LEAFLET_JS_HASH = 'sha384-cxOPjt7s7Iz04uaHJceBmS+qpjv2JkIHNVcuOrM+YHwZOmJGBXI00mdUXEq65HTH';
  var LEAFLET_CSS = 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.css';
  var LEAFLET_CSS_HASH = 'sha384-sHL9NAb7lN7rfvG5lfHpm643Xkcjzp4jFvuavGOndn6pjVqS6ny56CAt3nsEVT4H';
  var TILES = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
  var POSTCODE_URL = 'https://ws.geonorge.no/adresser/v1/sok?treffPerSide=1&utkoordsys=4258&postnummer=';
  var SAVED_POSTCODE = 'butikklagerPostnummer';
  var OPTIONS = ['option1', 'option2', 'option3'];
  var MAP_BAR_HEIGHT = 56;
  var ICONS = {
    check: '<circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.7 2.7L16 9.5"/>',
    truck: '<path d="M3 6h11v10H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7.5" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/>',
    phone: '<path d="M6 3h3l1.5 5-2 1.5a12 12 0 0 0 6 6l1.5-2 5 1.5v3a2 2 0 0 1-2 2A16 16 0 0 1 4 5a2 2 0 0 1 2-2z"/>'
  };

  var STYLES =
    '.butikklager-open{flex-wrap:wrap;width:100%;min-height:44px;border:0;font:inherit;color:inherit;text-align:left;text-transform:none;letter-spacing:normal;cursor:pointer}' +
    '.butikklager-open:hover{filter:brightness(.97)}' +
    '.butikklager-open__more{display:inline-flex;align-items:center;margin-left:auto;padding-left:.75em;white-space:nowrap}' +
    '.butikklager-open__label{text-decoration:underline;text-underline-offset:2px}' +
    '.butikklager-open__arrow{padding-left:.4em;font-size:1.3em;line-height:1;color:#64748b}' +
    'html.bl-open-page,html.bl-open-page body{overflow:hidden}' +
    '.bl-panel{position:fixed;top:0;right:0;bottom:0;left:auto;margin:0;padding:0;border:0;width:960px;max-width:100vw;height:100%;max-height:100%;background:#fff;color:#242424;font-size:16px;line-height:1.4;text-align:left;overflow:hidden}' +
    '@supports (height:100dvh){.bl-panel{height:100dvh;max-height:100dvh}}' +
    '.bl-panel[open]{display:flex}' +
    '.bl-panel::backdrop{background:rgba(0,0,0,var(--bl-dim,.5))}' +
    '.bl-panel.no-map{width:480px}' +
    '.bl-panel.no-map .bl-map-side{display:none}' +
    '.bl-map-side{position:relative;flex:1 1 auto;min-width:0;background:#e6ecef}' +
    '.bl-map{position:absolute;top:0;right:0;bottom:0;left:0}' +
    '.bl-locate{position:absolute;left:12px;bottom:26px;z-index:1000;display:flex;align-items:center;justify-content:center;width:40px;height:40px;padding:0;border:1px solid #d5d9de;border-radius:6px;background:#fff;color:#242424;cursor:pointer}' +
    '.bl-list-side{flex:0 0 480px;max-width:100%;box-sizing:border-box;padding:0 28px 24px;overflow-y:auto;overscroll-behavior:contain;touch-action:manipulation}' +
    '.bl-title{margin:18px 40px 2px;text-align:center;font-size:1.5rem;letter-spacing:0;text-transform:none}' +
    '.bl-close{position:absolute;top:10px;right:14px;z-index:1001;width:40px;height:40px;padding:0;border:1px solid #d5d9de;border-radius:50%;background:#fff;color:inherit;font-size:1.5rem;line-height:1;cursor:pointer}' +
    '.bl-title:focus{outline:none}' +
    '.bl-variant{margin:0 0 14px;text-align:center;font-size:.875rem;color:#64748b}' +
    '.bl-panel .bl-label{display:block;margin-bottom:6px;font-size:.9375rem;font-weight:400;letter-spacing:normal!important;text-transform:none!important}' +
    '.bl-search{display:flex;align-items:center;height:48px;padding:0 6px 0 14px;border:1px solid #e1e4e8;border-radius:6px;background:#fff;box-shadow:0 1px 5px rgba(0,0,0,.12)}' +
    '.bl-search input{flex:1 1 auto;min-width:0;height:100%;margin:0;padding:0;border:0;background:none;color:inherit;font:inherit;box-shadow:none;outline-offset:2px}' +
    '.bl-search button{display:flex;flex:none;align-items:center;justify-content:center;width:36px;height:36px;padding:0;border:0;background:none;color:#475569;font-size:1.375rem;line-height:1;cursor:pointer}' +
    '.bl-search-note{margin:6px 0 0;font-size:.875rem;color:#b42318}' +
    '.bl-search-note:empty{display:none}' +
    '.bl-tools{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:14px 0}' +
    '.bl-panel .bl-switch{display:inline-flex;align-items:center;gap:8px;margin:0;font-size:.9375rem;font-weight:400;letter-spacing:normal!important;text-transform:none!important;cursor:pointer}' +
    '.bl-switch input{position:absolute;opacity:0;width:0;height:0}' +
    '.bl-switch__track{position:relative;flex:none;width:44px;height:24px;border-radius:12px;background:#9aa3ad;transition:background .15s}' +
    '.bl-switch__track::after{content:"";position:absolute;top:2px;left:2px;width:20px;height:20px;border-radius:50%;background:#fff;transition:left .15s}' +
    '.bl-switch input:checked+.bl-switch__track{background:#61989f}' +
    '.bl-switch input:checked+.bl-switch__track::after{left:22px}' +
    '.bl-switch input:focus-visible+.bl-switch__track{outline:2px solid #242424;outline-offset:2px}' +
    '.bl-shops{list-style:none;margin:0;padding:0}' +
    '.bl-shop{margin:0 0 12px;border:1px solid #dfe3e7;border-radius:8px;background:#fff;transition:border-color .15s}' +
    '.bl-shop:hover{border-color:#aab3bc}' +
    '.bl-shop.is-selected{border-color:#61989f;box-shadow:0 0 0 1px #61989f}' +
    '.bl-shop__pick{display:block;width:100%;padding:14px 16px;border:0;background:none;color:inherit;font:inherit;text-align:left;text-transform:none;letter-spacing:normal;cursor:pointer}' +
    '.bl-shop__top{display:flex;justify-content:space-between;align-items:baseline;gap:12px}' +
    '.bl-shop__name{font-weight:700}' +
    '.bl-shop__far{flex:none;font-size:.8125rem;color:#475569}' +
    '.bl-shop__address{display:block;margin-bottom:10px;font-size:.875rem;color:#64748b}' +
    '.bl-status{display:grid;grid-template-columns:20px 1fr;column-gap:10px;padding:10px 12px;border-radius:6px;font-size:.875rem;line-height:1.35}' +
    '.bl-status__icon{display:flex;grid-row:1 / span 2;padding-top:1px}' +
    '.bl-status__title{font-weight:700}' +
    '.bl-status.is-in{background:#e8f4ec}' +
    '.bl-status.is-in .bl-status__icon,.bl-status.is-in .bl-status__title{color:#14672f}' +
    '.bl-status.is-order{background:#eaf2f3}' +
    '.bl-status.is-order .bl-status__icon{color:#3f7a82}' +
    '.bl-status.is-none{background:#f1f3f5}' +
    '.bl-status.is-none .bl-status__icon{color:#64748b}' +
    '.bl-have{display:block;margin-top:10px;font-size:.8125rem;color:#475569}' +
    '.bl-have__row{display:flex;flex-wrap:wrap;align-items:center;gap:6px;margin-top:6px}' +
    '.bl-have__name{flex:1 1 100%;color:#242424}' +
    '.bl-chip{min-width:22px;padding:1px 7px;border:1px solid #cfd4da;border-radius:4px;background:#fff;color:#242424;text-align:center}' +
    '.bl-chip.is-chosen{padding:0 6px;border:2px solid #242424;font-weight:700}' +
    '.bl-shop__more{padding:0 16px 12px}' +
    '.bl-buy{display:block;width:100%;min-height:48px;padding:0 16px;border:0;background:#61989f;color:#000;font:inherit;font-weight:600;font-size:.8125rem;letter-spacing:.2em;text-transform:uppercase;text-align:center;text-decoration:none;cursor:pointer}' +
    '.bl-buy:hover{filter:brightness(.95)}' +
    '.bl-hint{margin:6px 0 0;font-size:.8125rem;color:#475569}' +
    '.bl-foot{display:flex;justify-content:space-between;align-items:center;gap:12px;margin-top:10px;font-size:.875rem}' +
    '.bl-open{color:#475569}' +
    '.bl-open__head{font-weight:700}' +
    '.bl-open.is-open .bl-open__head{color:#14672f}' +
    '.bl-link{padding:0;border:0;background:none;color:inherit;font:inherit;text-decoration:underline;text-transform:none;letter-spacing:normal;cursor:pointer}' +
    '.bl-position{display:none;margin-left:auto;font-size:.9375rem}' +
    '.bl-info{position:absolute;top:50%;left:28px;z-index:1000;width:424px;max-width:calc(100vw - 24px);max-height:calc(100% - 24px);box-sizing:border-box;padding:20px;overflow-y:auto;border-radius:8px;background:#fff;box-shadow:0 4px 18px rgba(0,0,0,.28);transform:translate(0,-50%)}' +
    '.bl-info__close{position:absolute;top:8px;right:8px;width:36px;height:36px;padding:0;border:0;background:none;color:inherit;font-size:1.5rem;line-height:1;cursor:pointer}' +
    '.bl-info .bl-shop__top{padding-right:32px}' +
    '.bl-info .bl-open{display:block;margin:10px 0 8px;font-size:.9375rem}' +
    '.bl-hours{margin:0 0 14px;font-size:.9375rem}' +
    '.bl-hours__row{display:grid;grid-template-columns:5.5em 1fr auto;padding:2px 0}' +
    '.bl-hours__row.is-today{font-weight:700}' +
    '.bl-info__way{display:block;margin:0 0 14px;font-size:.9375rem}' +
    '.bl-info__page{display:block;margin-bottom:8px;padding:12px 16px;border:1px solid #242424;color:inherit;font-weight:600;font-size:.8125rem;letter-spacing:.2em;text-transform:uppercase;text-align:center;text-decoration:none}' +
    '.bl-info__back{display:block;margin:10px auto 0}' +
    '.bl-pin-wrap{background:none;border:0}' +
    '.bl-pin{display:block;width:26px;height:26px;margin:1px 0 0 1px;box-sizing:border-box;border:2px solid #fff;border-radius:50% 50% 50% 0;background:#242424;box-shadow:0 2px 4px rgba(0,0,0,.4);transform:rotate(-45deg)}' +
    '.bl-pin.is-in{background:#2e9e4f}' +
    '.bl-pin.is-selected{border-color:#61989f;box-shadow:0 0 0 3px #fff,0 2px 6px rgba(0,0,0,.5)}' +
    '.bl-grip,.bl-view-toggle{display:none}' +
    '@keyframes bl-up{from{transform:translateY(100%)}}' +
    '@media (max-width:767px){' +
      '.bl-panel,.bl-panel.no-map{top:16px;width:100vw;height:auto;max-height:none;border-radius:16px 16px 0 0}' +
      '.bl-panel[open]{flex-direction:column;animation:bl-up .25s ease-out}' +
      '.bl-grip{display:block;flex:none;position:relative;height:20px;touch-action:none}' +
      '.bl-grip::before,.bl-view-toggle::before{content:"";position:absolute;top:7px;left:50%;width:36px;height:4px;margin-left:-18px;border-radius:2px;background:#cfd4da}' +
      '.bl-map-side{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1000;background:none;transform:translateY(calc(100% - 56px));transition:transform .25s ease-out}' +
      '.bl-panel.is-map .bl-map-side{transform:none}' +
      '.bl-panel:not(.is-map) .bl-locate{visibility:hidden}' +
      '.bl-map{top:56px}' +
      '.bl-list-side{flex:1 1 0;min-height:0;padding:0 16px 76px}' +
      '.bl-title{margin:0 52px;font-size:1.25rem;touch-action:none}' +
      '.bl-variant{margin:0 8px 10px;touch-action:none}' +
      '.bl-close{top:6px;right:8px;width:44px;height:44px}' +
      '.bl-panel .bl-label{position:absolute;width:1px;height:1px;margin:0;overflow:hidden;clip-path:inset(50%)}' +
      '.bl-search{height:52px;padding:0 4px 0 14px}' +
      '.bl-search button{width:44px;height:44px}' +
      '.bl-tools{min-height:44px;margin:4px 0 6px}' +
      '.bl-panel .bl-switch{min-height:44px}' +
      '.bl-link{display:inline-flex;align-items:center;min-height:44px}' +
      '.bl-shop{margin-bottom:10px}' +
      '.bl-shop__pick{padding:12px 14px}' +
      '.bl-shop__pick:active{background:#f6f8f9}' +
      '.bl-shop:not(.is-selected) .bl-shop__top{margin-bottom:8px}' +
      '.bl-shop:not(.is-selected) .bl-shop__address{display:none}' +
      '.bl-shop__more{padding:0 14px 4px}' +
      '.bl-foot{margin-top:4px}' +
      '.bl-info__close{top:4px;right:4px;width:44px;height:44px}' +
      '.bl-locate{width:44px;height:44px}' +
      '.bl-panel .leaflet-touch .leaflet-bar a{width:44px;height:44px;line-height:44px}' +
      '.bl-info__way{display:flex;margin:0 0 6px}' +
      '.bl-info__back{display:flex;justify-content:center;margin:4px auto 0}' +
      '.bl-view-toggle{display:flex;position:absolute;top:0;right:0;left:0;align-items:center;justify-content:center;gap:8px;height:56px;padding:6px 56px 0;border:0;border-radius:16px 16px 0 0;background:#fff;color:inherit;font:inherit;font-weight:700;font-size:.9375rem;box-shadow:0 -2px 10px rgba(0,0,0,.14);cursor:pointer;touch-action:none}' +
      '.bl-info{left:50%;transform:translate(-50%,-50%)}' +
      '@media (prefers-reduced-motion:reduce){.bl-panel[open]{animation:none}.bl-map-side{transition:none}}' +
    '}';

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) { node.className = className; }
    if (text) { node.textContent = text; }
    return node;
  }

  function button(className, text, onClick) {
    var node = el('button', className, text);
    node.type = 'button';
    node.addEventListener('click', onClick);
    return node;
  }

  function onPhone() {
    return window.matchMedia('(max-width:767px)').matches;
  }

  function addStyles() {
    if (document.getElementById('butikklager-styles')) { return; }
    var style = document.createElement('style');
    style.id = 'butikklager-styles';
    style.textContent = STYLES;
    document.head.appendChild(style);
  }

  function stockData(variantId) {
    var scripts = document.querySelectorAll('script[data-butikklager]');
    for (var i = 0; i < scripts.length; i++) {
      var data;
      try { data = JSON.parse(scripts[i].textContent); } catch (e) { continue; }
      if (variantId in data) { return { stock: data, sizeOption: scripts[i].getAttribute('data-size-option') }; }
    }
    return null;
  }

  // Null for a product without the field, such as a part. A size of a bike that
  // HERO has not written yet is a bike that is in no shop.
  function readStock(variantId) {
    var found = stockData(variantId);
    if (!found) { return null; }
    var isBike = Object.keys(found.stock).some(function (id) { return found.stock[id]; });
    return isBike ? (found.stock[variantId] || {}) : null;
  }

  function allVariants(sectionId) {
    var source = document.getElementById('VariantsJson-' + sectionId);
    try { return JSON.parse(source.value); } catch (e) { return []; }
  }

  function sameExcept(a, b, option) {
    return OPTIONS.every(function (name) { return name === option || a[name] === b[name]; });
  }

  // Wheels and extras often share one barcode, so every choice of them reads as being
  // in the shop. An option that makes no difference in this shop is left out.
  function matters(option, shown, variants) {
    return shown.some(function (item) {
      return variants.some(function (other) {
        return other[option] !== item[option] && sameExcept(other, item, option) && shown.indexOf(other) < 0;
      });
    });
  }

  // Sizes grouped under what else tells them apart, usually the colour. Size can be
  // any of the three options, and sizes often carry a height in brackets.
  function groupOptions(shown, variants, sizeOption, chosen) {
    var others = OPTIONS.filter(function (name) { return name !== sizeOption && matters(name, shown, variants); });
    var groups = [];
    shown.forEach(function (item) {
      var name = others.map(function (option) { return item[option]; }).join(' / ');
      var group = groups.filter(function (candidate) { return candidate.name === name; })[0];
      if (!group) {
        group = { name: name, values: [] };
        groups.push(group);
      }
      var text = sizeOption ? String(item[sizeOption]).replace(/\s*\(.*\)$/, '') : '';
      if (!text || group.values.some(function (value) { return value.text === text; })) { return; }
      var isChosen = item[sizeOption] === chosen[sizeOption] && others.every(function (option) { return item[option] === chosen[option]; });
      group.values.push({ text: text, chosen: isChosen });
    });
    return groups.filter(function (group) { return group.name || group.values.length; });
  }

  // Everything of this bike that stands in each shop, not only the customer's choice.
  function displayByShop(sectionId, variant) {
    var found = stockData(variant.id);
    var variants = allVariants(sectionId);
    var byShop = {};
    SHOPS.forEach(function (shop) {
      var shown = variants.filter(function (item) { return found && (found.stock[item.id] || {})[shop.key]; });
      byShop[shop.key] = groupOptions(shown, variants, found && found.sizeOption, variant);
    });
    return byShop;
  }

  // The same sum updateStockDisplay uses for "(1-3 dagers levering)".
  function inWarehouse(sectionId, variantId) {
    var source = document.getElementById('VariantMetafieldsJson-' + sectionId);
    if (!source) { return false; }
    try {
      var fields = JSON.parse(source.innerHTML)[variantId] || {};
      return (parseInt(fields.spydeberg_quantity, 10) || 0) + (parseInt(fields.cube_lager_quantity, 10) || 0) > 0;
    } catch (e) { return false; }
  }

  function osloTime(date) {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Oslo', weekday: 'short', day: 'numeric', month: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(date).forEach(function (part) { parts[part.type] = part.value; });
    return {
      day: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday),
      date: parseInt(parts.day, 10) + '.' + parseInt(parts.month, 10) + '.',
      time: parts.hour + ':' + parts.minute
    };
  }

  function minutes(time) {
    return parseInt(time.slice(0, 2), 10) * 60 + parseInt(time.slice(3), 10);
  }

  function openStatus(shop) {
    var now = osloTime(new Date());
    var today = shop.hours[now.day];
    if (today && now.time >= today[0] && now.time < today[1]) {
      var soon = minutes(today[1]) - minutes(now.time) <= 60;
      return { open: true, head: 'Åpent nå', rest: soon ? 'Stenger snart, klokken ' + today[1] : 'Åpent til ' + today[1] };
    }
    if (today && now.time < today[0]) { return { open: false, head: 'Stengt', rest: 'Åpner kl. ' + today[0] }; }
    for (var i = 1; i < 8; i++) {
      var day = (now.day + i) % 7;
      if (shop.hours[day]) {
        return { open: false, head: 'Stengt', rest: 'Åpner ' + (i === 1 ? 'i morgen' : DAYS[day].toLowerCase()) + ' kl. ' + shop.hours[day][0] };
      }
    }
    return { open: false, head: 'Stengt', rest: '' };
  }

  function openLine(shop) {
    var status = openStatus(shop);
    var line = el('span', 'bl-open' + (status.open ? ' is-open' : ''));
    line.appendChild(el('span', 'bl-open__head', status.head));
    if (status.rest) { line.appendChild(document.createTextNode(' - ' + status.rest)); }
    return line;
  }

  var view = null;
  var leaflet = null;
  var shopMap = null;
  var pins = {};
  var here = null;

  function shopByKey(key) {
    return SHOPS.filter(function (shop) { return shop.key === key; })[0] || null;
  }

  function kmFrom(origin, shop) {
    var rad = Math.PI / 180;
    var dLat = (shop.lat - origin.lat) * rad;
    var dLng = (shop.lng - origin.lng) * rad;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(origin.lat * rad) * Math.cos(shop.lat * rad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 12742 * Math.asin(Math.sqrt(a));
  }

  function distanceText(shop) {
    if (!view.origin) { return ''; }
    var km = kmFrom(view.origin, shop);
    return (km < 10 ? km.toFixed(1).replace('.', ',') : String(Math.round(km))) + ' km unna';
  }

  function visibleShops() {
    return SHOPS.filter(function (shop) { return !view.onlyThere || view.stock[shop.key]; });
  }

  function shopsInOrder() {
    return visibleShops().sort(function (a, b) {
      if (view.selected === a.key) { return -1; }
      if (view.selected === b.key) { return 1; }
      if (view.origin) { return kmFrom(view.origin, a) - kmFrom(view.origin, b); }
      return (view.stock[b.key] ? 1 : 0) - (view.stock[a.key] ? 1 : 0);
    });
  }

  // One plain answer per shop: what is true now, and what the customer can do about it.
  function statusFor(shop) {
    if (view.stock[shop.key]) {
      return { kind: 'is-in', icon: 'check', title: 'Utstilt i butikk', text: view.deliverable ? 'Se og kjøp den her, eller få den sendt hit på 1-3 dager.' : 'Se og kjøp den her.' };
    }
    var title = view.onDisplay[shop.key].length ? 'Ditt valg er ikke utstilt her nå' : 'Ikke utstilt her nå';
    if (view.deliverable) { return { kind: 'is-order', icon: 'truck', title: title, text: 'Vi kan få den hit på 1-3 dager.' }; }
    return { kind: 'is-none', icon: 'phone', title: title, text: 'Kontakt oss for leveringstid.' };
  }

  function statusBlock(shop) {
    var status = statusFor(shop);
    var block = el('span', 'bl-status ' + status.kind);
    var icon = el('span', 'bl-status__icon');
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + ICONS[status.icon] + '</svg>';
    block.appendChild(icon);
    block.appendChild(el('span', 'bl-status__title', status.title));
    block.appendChild(el('span', 'bl-status__text', status.text));
    return block;
  }

  // Left out when the only thing to list is what the row above has already said.
  function displayList(shop) {
    var groups = view.onDisplay[shop.key];
    var count = groups.reduce(function (sum, group) { return sum + Math.max(group.values.length, 1); }, 0);
    if (!count || (view.stock[shop.key] && count < 2)) { return null; }
    var list = el('span', 'bl-have');
    var title = el('span', '', 'Utstilt her:');
    if (groups[0].name) { list.appendChild(title); }
    groups.forEach(function (group) {
      var row = el('span', 'bl-have__row');
      row.appendChild(group.name ? el('span', 'bl-have__name', group.name) : title);
      group.values.forEach(function (value) {
        row.appendChild(el('span', 'bl-chip' + (value.chosen ? ' is-chosen' : ''), value.text));
      });
      list.appendChild(row);
    });
    return list;
  }

  function shopFacts(shop, parent) {
    parent.appendChild(statusBlock(shop));
    var list = displayList(shop);
    if (list) { parent.appendChild(list); }
  }

  function buyButton() {
    return document.querySelector('.add-to-cart[name="add"]');
  }

  function canOrder(shop) {
    var buy = buyButton();
    return Boolean(buy && !buy.disabled && (view.stock[shop.key] || view.deliverable));
  }

  // The theme reads the form during the click, so the shop lands on this order line
  // and the next plain add does not get it.
  function addFromShop(shop) {
    var field = document.getElementById('stock-status-property');
    var seen = field ? field.value : '';
    var note = 'Valgt butikk: ' + shop.city;
    if (field) { field.value = seen ? seen + ' | ' + note : note; }
    panel().close();
    buyButton().click();
    if (field) { field.value = seen; }
  }

  function orderBlock(shop, parent) {
    if (!canOrder(shop)) { return; }
    parent.appendChild(button('bl-buy', 'Legg i handlevogn', function () { addFromShop(shop); }));
    parent.appendChild(el('p', 'bl-hint', 'Velg «Hente i vår butikk i ' + shop.city + '» i kassen.'));
  }

  function shopDetails(shop) {
    var more = el('div', 'bl-shop__more');
    orderBlock(shop, more);
    var foot = el('div', 'bl-foot');
    foot.appendChild(openLine(shop));
    foot.appendChild(button('bl-link', 'Butikkinformasjon', function () { showInfo(shop); }));
    more.appendChild(foot);
    return more;
  }

  function shopTop(shop) {
    var top = el('span', 'bl-shop__top');
    top.appendChild(el('span', 'bl-shop__name', shop.name));
    var far = distanceText(shop);
    if (far) { top.appendChild(el('span', 'bl-shop__far', far)); }
    return top;
  }

  function shopCard(shop) {
    var selected = view.selected === shop.key;
    var card = el('li', 'bl-shop' + (selected ? ' is-selected' : ''));
    var pick = button('bl-shop__pick', '', function () { select(selected ? null : shop.key); });
    pick.setAttribute('aria-expanded', String(selected));
    pick.appendChild(shopTop(shop));
    pick.appendChild(el('span', 'bl-shop__address', shop.address));
    shopFacts(shop, pick);
    card.appendChild(pick);
    if (selected) { card.appendChild(shopDetails(shop)); }
    return card;
  }

  function renderShops() {
    var list = panel().querySelector('.bl-shops');
    list.textContent = '';
    shopsInOrder().forEach(function (shop) { list.appendChild(shopCard(shop)); });
  }

  function fitShops() {
    shopMap.fitBounds(visibleShops().map(function (shop) { return [shop.lat, shop.lng]; }), { padding: [56, 56], maxZoom: 12 });
  }

  function markPins() {
    Object.keys(pins).forEach(function (key) {
      var node = pins[key].getElement();
      if (node) { node.firstChild.classList.toggle('is-selected', key === view.selected); }
    });
  }

  // The switch filters the map as well as the list, as Elkjøp's does.
  function showPins() {
    Object.keys(pins).forEach(function (key) {
      if (!view.onlyThere || view.stock[key]) { pins[key].addTo(shopMap); } else { pins[key].remove(); }
    });
    markPins();
  }

  function focusShop() {
    var shop = shopByKey(view.selected);
    if (shop) {
      shopMap.setView([shop.lat, shop.lng], 14, { animate: false });
      pins[shop.key].openPopup();
    } else {
      shopMap.closePopup();
      fitShops();
    }
  }

  function select(key) {
    view.selected = key;
    closeInfo();
    renderShops();
    panel().querySelector('.bl-list-side').scrollTop = 0;
    if (!shopMap) { return; }
    markPins();
    focusShop();
  }

  function closeInfo() {
    var open = panel().querySelector('.bl-info');
    if (open) { open.remove(); }
  }

  // Rows, not a table: the theme styles every table on the site dark.
  function hoursList(shop) {
    var list = el('div', 'bl-hours');
    for (var i = 0; i < 7; i++) {
      var when = osloTime(new Date(Date.now() + i * 86400000));
      var hours = shop.hours[when.day];
      var row = el('div', 'bl-hours__row' + (i === 0 ? ' is-today' : ''));
      row.appendChild(el('span', '', DAYS[when.day]));
      row.appendChild(el('span', '', when.date));
      row.appendChild(el('span', '', hours ? hours[0] + ' - ' + hours[1] : 'Stengt'));
      list.appendChild(row);
    }
    return list;
  }

  // Sits on top of the map, the way Elkjøp's Butikkinformasjon does.
  function showInfo(shop) {
    closeInfo();
    var box = el('section', 'bl-info');
    box.setAttribute('aria-label', 'Butikkinformasjon for ' + shop.name);
    var close = button('bl-info__close', '×', closeInfo);
    close.setAttribute('aria-label', 'Lukk butikkinformasjon');
    box.appendChild(close);
    box.appendChild(shopTop(shop));
    box.appendChild(el('span', 'bl-shop__address', shop.address));
    shopFacts(shop, box);
    box.appendChild(openLine(shop));
    box.appendChild(hoursList(shop));
    var way = el('a', 'bl-link bl-info__way', 'Veibeskrivelse');
    way.href = 'https://www.google.com/maps/dir/?api=1&destination=' + shop.lat + ',' + shop.lng;
    way.target = '_blank';
    way.rel = 'noopener';
    box.appendChild(way);
    var page = el('a', 'bl-info__page', 'Gå til butikkens side');
    page.href = shop.url;
    box.appendChild(page);
    orderBlock(shop, box);
    box.appendChild(button('bl-link bl-info__back', 'Tilbake til liste over butikker', closeInfo));
    panel().appendChild(box);
    close.focus();
  }

  function loadLeaflet() {
    if (leaflet) { return leaflet; }
    leaflet = new Promise(function (resolve, reject) {
      // Everything in the map measures itself when it is drawn, so the styles must
      // be in first. Another script on the page already uses window.L: give it back.
      var waiting = 2;
      function loaded() {
        waiting -= 1;
        if (!waiting) { resolve(window.L.noConflict()); }
      }
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = LEAFLET_CSS;
      css.integrity = LEAFLET_CSS_HASH;
      css.crossOrigin = 'anonymous';
      css.onload = loaded;
      css.onerror = reject;
      document.head.appendChild(css);
      var js = document.createElement('script');
      js.src = LEAFLET_JS;
      js.integrity = LEAFLET_JS_HASH;
      js.crossOrigin = 'anonymous';
      js.onload = loaded;
      js.onerror = reject;
      document.head.appendChild(js);
    });
    return leaflet;
  }

  function closeMap() {
    if (shopMap) { shopMap.remove(); shopMap = null; }
    pins = {};
    here = null;
  }

  function drawMap() {
    var box = panel().querySelector('.bl-map');
    if (!box || !box.offsetWidth) { return; }
    if (shopMap) { shopMap.invalidateSize(); return; }
    loadLeaflet().then(function (L) {
      if (!box.isConnected || shopMap) { return; }
      shopMap = L.map(box);
      shopMap.attributionControl.setPrefix(false);
      L.tileLayer(TILES, { maxZoom: 19, attribution: '© <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>-bidragsytere' }).addTo(shopMap);
      SHOPS.forEach(function (shop) {
        var icon = L.divIcon({ className: 'bl-pin-wrap', html: '<span class="bl-pin' + (view.stock[shop.key] ? ' is-in' : '') + '"></span>', iconSize: [28, 38], iconAnchor: [14, 36] });
        pins[shop.key] = L.marker([shop.lat, shop.lng], { icon: icon, title: shop.name, alt: shop.name })
          .bindPopup(shop.name, { closeButton: false, autoPan: false, offset: [0, -28] })
          .on('click', function () { showList(); select(shop.key); });
      });
      showPins();
      focusShop();
    }).catch(function () {
      panel().classList.add('no-map');
    });
  }

  function viewToggleText() {
    return panel().classList.contains('is-map') ? 'Se liste over butikker ⌄' : 'Se kartoversikt ⌃';
  }

  function setMapView(on) {
    var dialog = panel();
    dialog.classList.toggle('is-map', on);
    dialog.querySelector('.bl-view-toggle').textContent = viewToggleText();
    if (on) { drawMap(); }
  }

  function showList() {
    setMapView(false);
  }

  function toggleView() {
    setMapView(!panel().classList.contains('is-map'));
  }

  function savedPostcode() {
    try { return JSON.parse(window.localStorage.getItem(SAVED_POSTCODE)); } catch (e) { return null; }
  }

  function savePostcode(origin) {
    try {
      if (origin) { window.localStorage.setItem(SAVED_POSTCODE, JSON.stringify(origin)); } else { window.localStorage.removeItem(SAVED_POSTCODE); }
    } catch (e) { /* the search still works for this visit */ }
  }

  function forgetPosition() {
    if (here) { here.remove(); here = null; }
    document.getElementById('ButikklagerPostnummer').placeholder = 'Oppgi postnummer';
  }

  function setOrigin(origin) {
    view.origin = origin;
    savePostcode(origin);
    forgetPosition();
    renderShops();
  }

  // For this visit only: the position is not saved, unlike a postcode.
  function locate() {
    var note = panel().querySelector('.bl-search-note');
    note.textContent = '';
    navigator.geolocation.getCurrentPosition(function (position) {
      var spot = { code: '', lat: position.coords.latitude, lng: position.coords.longitude };
      var input = document.getElementById('ButikklagerPostnummer');
      input.value = '';
      input.placeholder = 'Min posisjon';
      view.origin = spot;
      renderShops();
      if (!shopMap) { return; }
      loadLeaflet().then(function (L) {
        if (!shopMap) { return; }
        if (here) { here.remove(); }
        here = L.circleMarker([spot.lat, spot.lng], { radius: 7, color: '#fff', weight: 2, fillColor: '#2563eb', fillOpacity: 1 }).addTo(shopMap);
      });
    }, function () {
      note.textContent = 'Fikk ikke tak i posisjonen din.';
    }, { timeout: 8000 });
  }

  function searchPostcode(code, note) {
    note.textContent = '';
    if (!/^\d{4}$/.test(code)) { note.textContent = 'Skriv et postnummer med fire siffer.'; return; }
    fetch(POSTCODE_URL + code).then(function (response) { return response.json(); }).then(function (data) {
      var hit = data.adresser && data.adresser[0];
      if (!hit) { note.textContent = 'Fant ikke postnummeret.'; return; }
      setOrigin({ code: code, lat: hit.representasjonspunkt.lat, lng: hit.representasjonspunkt.lon });
      document.getElementById('ButikklagerPostnummer').blur();
    }).catch(function () {
      note.textContent = 'Kunne ikke søke akkurat nå.';
    });
  }

  function searchBox(parent) {
    var label = el('label', 'bl-label', 'Vis butikker i nærheten av');
    label.setAttribute('for', 'ButikklagerPostnummer');
    parent.appendChild(label);
    var box = el('div', 'bl-search');
    var input = el('input');
    input.id = 'ButikklagerPostnummer';
    input.type = 'text';
    input.inputMode = 'numeric';
    input.enterKeyHint = 'search';
    input.maxLength = 4;
    input.autocomplete = 'postal-code';
    input.placeholder = 'Oppgi postnummer';
    input.value = view.origin ? view.origin.code : '';
    var note = el('p', 'bl-search-note');
    note.setAttribute('role', 'status');
    input.addEventListener('input', function () {
      if (input.value.length === 4) { searchPostcode(input.value, note); }
    });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') { event.preventDefault(); searchPostcode(input.value, note); }
    });
    box.appendChild(input);
    var clear = button('', '×', function () {
      input.value = '';
      note.textContent = '';
      setOrigin(null);
      input.focus();
    });
    clear.setAttribute('aria-label', 'Tøm postnummer');
    box.appendChild(clear);
    var go = button('', '', function () { searchPostcode(input.value, note); });
    go.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.5-4.5"/></svg>';
    go.setAttribute('aria-label', 'Søk');
    box.appendChild(go);
    parent.appendChild(box);
    parent.appendChild(note);
  }

  function onlyThereSwitch(parent) {
    if (!SHOPS.some(function (shop) { return view.stock[shop.key]; })) { return; }
    var label = el('label', 'bl-switch');
    var input = el('input');
    input.type = 'checkbox';
    input.setAttribute('role', 'switch');
    input.addEventListener('change', function () {
      view.onlyThere = input.checked;
      if (view.onlyThere && view.selected && !view.stock[view.selected]) { view.selected = null; }
      renderShops();
      if (shopMap) { showPins(); focusShop(); }
    });
    label.appendChild(input);
    label.appendChild(el('span', 'bl-switch__track'));
    label.appendChild(document.createTextNode('Utstilt i butikk'));
    parent.appendChild(label);
  }

  // The map has its own position button, and a phone starts on the list without it.
  function listTools(parent) {
    var tools = el('div', 'bl-tools');
    onlyThereSwitch(tools);
    if (navigator.geolocation) { tools.appendChild(button('bl-link bl-position', 'Bruk min posisjon', locate)); }
    parent.appendChild(tools);
  }

  // On a phone the sheet follows the finger down and closes, and the bar brings the map
  // up over the list or back down. A short drag slides back. Everything also works by
  // tapping, because the grip is easy to miss and some people never try to drag.
  var drag = null;

  function startDrag(event) {
    drag = null;
    if (!onPhone() || event.touches.length > 1) { return; }
    var list = panel().querySelector('.bl-list-side');
    var onBar = event.target.closest('.bl-view-toggle');
    var onGrip = event.target.closest('.bl-grip');
    var atTopOfList = list.contains(event.target) && list.scrollTop <= 0;
    if (!onBar && !onGrip && !atTopOfList) { return; }
    drag = { bar: Boolean(onBar), startY: event.touches[0].clientY, startedAt: event.timeStamp, lastAt: event.timeStamp, moved: 0, active: false };
  }

  function followWithMap(moved) {
    var dialog = panel();
    var layer = dialog.querySelector('.bl-map-side');
    var resting = dialog.clientHeight - MAP_BAR_HEIGHT;
    var from = dialog.classList.contains('is-map') ? 0 : resting;
    layer.style.transition = 'none';
    layer.style.transform = 'translateY(' + Math.min(resting, Math.max(0, from + moved)) + 'px)';
  }

  function followWithSheet(moved) {
    var dialog = panel();
    var down = Math.max(0, moved);
    dialog.style.transition = 'none';
    dialog.style.transform = 'translateY(' + down + 'px)';
    dialog.style.setProperty('--bl-dim', (0.5 * (1 - down / dialog.clientHeight)).toFixed(2));
  }

  function moveDrag(event) {
    if (!drag) { return; }
    var moved = event.touches[0].clientY - drag.startY;
    if (!drag.active) {
      // Left alone until the finger has clearly moved, so a tap stays a tap. Upwards on
      // the list is scrolling, and once the browser has begun scrolling it keeps the finger.
      if (Math.abs(moved) < 8) { return; }
      if (!event.cancelable || (!drag.bar && moved < 0)) { drag = null; return; }
      drag.active = true;
      if (drag.bar) { drawMap(); }
    }
    event.preventDefault();
    drag.moved = moved;
    drag.lastAt = event.timeStamp;
    if (drag.bar) { followWithMap(moved); } else { followWithSheet(moved); }
  }

  // The finger lifting after a drag must not also press what it is resting on.
  function swallowNextClick(dialog) {
    function stop(event) {
      event.stopPropagation();
      event.preventDefault();
    }
    dialog.addEventListener('click', stop, true);
    window.setTimeout(function () { dialog.removeEventListener('click', stop, true); }, 350);
  }

  function endDrag() {
    var finished = drag;
    drag = null;
    if (!finished || !finished.active) { return; }
    var dialog = panel();
    var distance = Math.abs(finished.moved);
    var flicked = distance > 40 && distance / (finished.lastAt - finished.startedAt) > 0.5;
    var farEnough = distance > 120 || flicked;
    swallowNextClick(dialog);
    if (finished.bar) {
      var layer = dialog.querySelector('.bl-map-side');
      layer.style.transition = '';
      layer.style.transform = '';
      if (farEnough) { setMapView(finished.moved < 0); }
      return;
    }
    dialog.style.transition = 'transform .2s ease-out';
    if (farEnough && finished.moved > 0) {
      dialog.style.transform = 'translateY(100%)';
      window.setTimeout(function () { dialog.close(); }, 200);
      return;
    }
    dialog.style.transform = '';
    dialog.style.removeProperty('--bl-dim');
  }

  function panel() {
    var dialog = document.getElementById('ButikklagerPanel');
    if (dialog) { return dialog; }
    dialog = el('dialog', 'bl-panel');
    dialog.id = 'ButikklagerPanel';
    dialog.setAttribute('aria-labelledby', 'ButikklagerPanelTitle');
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) { dialog.close(); }
    });
    dialog.addEventListener('touchstart', startDrag, { passive: true });
    dialog.addEventListener('touchmove', moveDrag, { passive: false });
    dialog.addEventListener('touchend', endDrag);
    dialog.addEventListener('touchcancel', endDrag);
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('bl-open-page');
      dialog.style.transform = '';
      dialog.style.transition = '';
      dialog.style.removeProperty('--bl-dim');
      closeMap();
      if (window.history.state && window.history.state.butikklager) { window.history.back(); }
    });
    document.body.appendChild(dialog);
    return dialog;
  }

  function openPanel(stock, variant, deliverable, onDisplay) {
    view = { stock: stock, variant: variant, deliverable: deliverable, onDisplay: onDisplay, origin: savedPostcode(), onlyThere: false, selected: null };
    var dialog = panel();
    dialog.textContent = '';
    dialog.classList.remove('is-map');

    var grip = el('div', 'bl-grip');
    grip.setAttribute('aria-hidden', 'true');
    dialog.appendChild(grip);

    var mapSide = el('div', 'bl-map-side');
    mapSide.appendChild(el('div', 'bl-map'));
    mapSide.appendChild(button('bl-view-toggle', 'Se kartoversikt ⌃', toggleView));
    if (navigator.geolocation) {
      var locateButton = button('bl-locate', '', locate);
      locateButton.setAttribute('aria-label', 'Bruk min posisjon');
      locateButton.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 21s7-6.2 7-11.5A7 7 0 0 0 5 9.5C5 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>';
      mapSide.appendChild(locateButton);
    }
    dialog.appendChild(mapSide);

    var listSide = el('div', 'bl-list-side');
    var title = el('h2', 'bl-title', 'Finn butikk');
    title.id = 'ButikklagerPanelTitle';
    // Left alone, the browser puts focus on the postcode field and a phone opens its
    // keyboard over the list. Autofocus makes the title the first stop instead.
    title.setAttribute('tabindex', '-1');
    title.setAttribute('autofocus', '');
    listSide.appendChild(title);
    if (variant.title) { listSide.appendChild(el('p', 'bl-variant', variant.title)); }
    searchBox(listSide);
    listTools(listSide);
    listSide.appendChild(el('ul', 'bl-shops'));
    dialog.appendChild(listSide);

    var close = button('bl-close', '×', function () { dialog.close(); });
    close.setAttribute('aria-label', 'Lukk');
    dialog.appendChild(close);

    renderShops();
    dialog.showModal();
    document.documentElement.classList.add('bl-open-page');
    title.focus({ preventScroll: true });
    window.history.pushState({ butikklager: true }, '');
    // A phone starts on the list, and many never open the map: don't download it yet.
    if (!onPhone()) { drawMap(); }
  }

  // The panel fills a phone's screen, so Back should close it, not leave the page.
  window.addEventListener('popstate', function () {
    var dialog = document.getElementById('ButikklagerPanel');
    if (dialog && dialog.open) { dialog.close(); }
  });

  // Back from a shop's page reloads this page without the panel, on the entry the
  // panel added. Step off it, or the next Back seems to do nothing.
  if (window.history.state && window.history.state.butikklager) { window.history.back(); }

  function names(shops) {
    return shops.map(function (shop) { return shop.city; }).join(', ');
  }

  // The theme's own stock line becomes the button, so there is no extra line to read.
  function makeOpener(line, label, open) {
    var opener = button(line.className + ' butikklager-open', '', open);
    opener.setAttribute('aria-haspopup', 'dialog');
    while (line.firstChild) { opener.appendChild(line.firstChild); }
    var more = el('span', 'butikklager-open__more');
    if (label) { more.appendChild(el('span', 'butikklager-open__label', label)); }
    var arrow = el('span', 'butikklager-open__arrow', '›');
    arrow.setAttribute('aria-hidden', 'true');
    more.appendChild(arrow);
    opener.appendChild(more);
    line.parentNode.replaceChild(opener, line);
  }

  // Lagerstatus follows the order line, so it says what the customer saw.
  function recordOnOrder(shops) {
    var field = document.getElementById('stock-status-property');
    if (!field) { return; }
    var text = 'Utstilt i butikk: ' + names(shops);
    var seen = field.value || '';
    field.value = !seen || seen.indexOf('Kommer på lager') === 0 ? text : seen + ' | ' + text;
  }

  function render(container, sectionId, variant) {
    var stock = readStock(variant.id);
    if (!stock) { return; }

    var box = container.querySelector('#variant-stock-list .stock-availability');
    if (!box || box.querySelector('button.butikklager-open')) { return; }

    var shops = SHOPS.filter(function (shop) { return stock[shop.key]; });
    var deliverable = inWarehouse(sectionId, variant.id);
    var onDisplay = displayByShop(sectionId, variant);
    var anywhere = SHOPS.some(function (shop) { return onDisplay[shop.key].length; });
    if (!shops.length && !deliverable && !anywhere) { return; }

    addStyles();
    function open() { openPanel(stock, variant, deliverable, onDisplay); }

    var line = box.querySelector('.stock-availability__main, .stock-availability__supplier');
    var waiting = box.querySelector('.stock-availability__unavailable');
    if (line) {
      var label = deliverable ? 'Også utstilt i butikk' : 'Utstilt i butikk';
      makeOpener(line, shops.length ? label : 'Se butikker', open);
    } else if (shops.length) {
      // Only "Kommer på lager" is left, which is not true when the bike stands in a shop.
      var status = el('div', 'stock-availability__main');
      status.appendChild(el('span', 'stock-availability__icon', '🏬'));
      status.appendChild(el('span', 'stock-availability__status', 'Utstilt i butikk: ' + names(shops)));
      if (waiting) { waiting.parentNode.replaceChild(status, waiting); } else { box.appendChild(status); }
      makeOpener(status, '', open);
    } else if (waiting) {
      // This choice is on its way, but another size or colour stands in a shop.
      makeOpener(waiting, 'Se butikker', open);
    }

    if (shops.length) { recordOnOrder(shops); }
  }

  var original = theme.Product.prototype.updateStockDisplay;

  theme.Product.prototype.updateStockDisplay = function (variant) {
    original.call(this, variant);
    if (variant) { render(this.$container[0], this.sectionId, variant); }
  };

  // theme.js can build the page before this file has downloaded, and then the call
  // above never happens for the first variant. Catch up here, so the order of the
  // two files does not matter.
  function currentVariant(sectionId, id) {
    return allVariants(sectionId).filter(function (variant) { return String(variant.id) === String(id); })[0] || { id: id };
  }

  var section = document.querySelector('#variant-stock-list .stock-availability');
  section = section && section.closest('[data-section-id]');
  var field = section && section.querySelector('[name="id"]');
  if (field && field.value) {
    var sectionId = section.getAttribute('data-section-id');
    render(section, sectionId, currentVariant(sectionId, field.value));
  }
})();
